var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { Typography, Box } from '@mui/material';
export var NuggetResource = function (_a) {
    var variant = _a.variant;
    if (variant.type === 'LARGE') {
        return (_jsxs(_Fragment, { children: [variant.previewImage && (_jsx(Box, { sx: imageContainerStyle, children: _jsx("img", { src: variant.previewImage, alt: variant.title, style: imageStyle }) })), variant.url && (_jsx(Typography, { sx: bottomTextStyle, variant: "body1", onClick: function () { return window.open(variant.url, '_blank'); }, children: variant.title }))] }));
    }
    return (_jsx(_Fragment, { children: variant.previewImage && (_jsx(Box, { sx: smallImageContainerStyle, children: _jsx("img", { src: variant.previewImage, alt: variant.title, style: smallImageStyle }) })) }));
};
var bottomTextStyle = {
    fontFamily: 'Sarabun',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    mt: 2,
    mb: 3,
    textDecoration: 'underline',
    cursor: 'pointer',
    maxWidth: '100%',
    fontStyle: 'italic',
    color: appColors.color.blue1,
};
var imageContainerStyle = {
    borderRadius: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    width: '100%',
    mt: 2,
    objectFit: 'cover',
    aspectRatio: '16 / 9',
};
var smallImageContainerStyle = __assign(__assign({}, imageContainerStyle), { maxHeight: '150px', minHeight: 'unset', width: '100%', backgroundColor: 'transparent' });
var imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '16px',
};
var smallImageStyle = {
    width: '100%',
    objectFit: 'contain',
};
